// TEAMS Website - Events Data
// Real concert and performance information from Claudio Carmelo Andriani's career

/*
{
  // Add these fields when content exists:
  gallery: ['/path/to/image1.jpg', '/path/to/image2.jpg'],
  videos: [{ title: '', url: '', description: '' }],
  articles: [{ title: '', publication: '', date: '', url: '', excerpt: '' }],
  reviews: [{ author: '', source: '', rating: 5, text: '' }]
}
*/
export const events = [
  {
    slug: 'alessandria-conservatorio-2026-02',
    title: {
      en: 'Chamber Music Concert',
      it: 'Concerto di Musica da Camera'
    },
    subtitle: {
      en: 'I Mercoledì del Conservatorio',
      it: 'I Mercoledì del Conservatorio'
    },
    description: {
      en: 'Chamber music performance with Nicola Bignami and Claudio Merlo.',
      it: 'Esibizione di musica da camera con Nicola Bignami e Claudio Merlo.'
    },
    fullDescription: {
      en: 'A chamber music concert as part of the "I Mercoledì del Conservatorio" series at Auditorium Pittaluga in Alessandria, featuring collaborations with Nicola Bignami and Claudio Merlo.',
      it: 'Un concerto di musica da camera come parte della serie "I Mercoledì del Conservatorio" all\'Auditorium Pittaluga di Alessandria, con collaborazioni con Nicola Bignami e Claudio Merlo.'
    },
    type: 'concert',
    date: '2026-02-11',
    time: '20:30',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: 'https://placehold.co/600x400/4169E1/FFFFFF?text=Auditorium+Pittaluga&font=playfair-display',
    ticketUrl: 'https://alessandria.today/2025/11/21/ritorna-ad-alessandria-la-buona-musica-con-i-mercoledi-del-conservatorio/',
    performers: [
      'Claudio Andriani',
      'Nicola Bignami',
      'Claudio Merlo'
    ],
    featured: false
  },
  {
    slug: 'carnegie-hall-2026',
    title: {
      en: 'Shadows of Sound - A composer portrait concert',
      it: 'Shadows of Sound - Un ritratto del compositore in concerto'
    },
    subtitle: {
      en: 'Quartetto Andriani at Carnegie Hall',
      it: 'Quartetto Andriani alla Carnegie Hall'
    },
    description: {
      en: 'A special concert featuring the music of composer Federico Favali performed by Quartetto Andriani.',
      it: 'Un concerto speciale con la musica del compositore Federico Favali eseguita dal Quartetto Andriani.'
    },
    fullDescription: {
      en: 'Quartetto Andriani presents "Shadows of Sound - A composer portrait concert" featuring works by composer Federico Favali. This prestigious performance takes place at Carnegie Hall\'s Weill Recital Hall, showcasing the ensemble\'s interpretation of contemporary classical works.',
      it: 'Il Quartetto Andriani presenta "Shadows of Sound - Un ritratto del compositore in concerto" con opere del compositore Federico Favali. Questa prestigiosa esibizione si tiene presso la Weill Recital Hall della Carnegie Hall, mostrando l\'interpretazione dell\'ensemble di opere classiche contemporanee.'
    },
    type: 'concert',
    date: '2026-02-06',
    time: '20:00',
    location: {
      name: 'Carnegie Hall',
      address: '881 7th Ave, New York, NY 10019',
      city: 'New York',
      country: 'USA'
    },
    image: '/events/2026-andriani-carangiehall/quartetto-tehilla.jpeg',
    gallery: [
      '/events/2026-andriani-carangiehall/slideshow/quartetto-tehilla e .jpeg',
      '/events/2026-andriani-carangiehall/slideshow/quartettoandriani.jpeg'
    ],
    ticketUrl: 'https://www.carnegiehall.org/Calendar/2026/02/06/Quartetto-Andriani-0800PM',
    performers: [
      'Quartetto Andriani (Claudio Andriani - First Violin)',
      'Tehilla Meller Andriani (Flauto / Recorder)',
      'Federico Favali (composer)'
    ],
    featured: true
  },
  {
    slug: 'valenza-teatro-2026',
    title: {
      en: 'Fughe d\'inverno - Dialoghi del tempo',
      it: 'Fughe d\'inverno - Dialoghi del tempo'
    },
    subtitle: {
      en: 'Winter Fugues - Dialogues of Time',
      it: 'Fughe d\'inverno - Dialoghi del tempo'
    },
    description: {
      en: 'A concert series exploring temporal dialogues through music.',
      it: 'Una serie di concerti che esplora dialoghi temporali attraverso la musica.'
    },
    fullDescription: {
      en: '"Fughe d\'inverno - Dialoghi del tempo" is a concert series running from January 24 to March 7, 2026 at Teatro Sociale di Valenza, exploring the concept of time through musical dialogues and fugues.',
      it: '"Fughe d\'inverno - Dialoghi del tempo" è una serie di concerti che si svolge dal 24 gennaio al 7 marzo 2026 al Teatro Sociale di Valenza, esplorando il concetto di tempo attraverso dialoghi musicali e fughe.'
    },
    type: 'concert',
    date: '2026-01-24',
    time: '21:00',
    location: {
      name: 'Teatro Sociale di Valenza',
      address: 'Piazza Vittorio Emanuele II, Valenza',
      city: 'Valenza',
      country: 'Italy'
    },
    image: 'https://placehold.co/600x400/2E8B57/FFFFFF?text=Teatro+Sociale&font=playfair-display',
    ticketUrl: 'https://www.alessandria24.com/2026/01/08/al-teatro-sociale-valenza-dal-24-gennaio-al-7-marzo-torna-fughe-dinverno-il-programma-di-appuntamenti/',
    performers: [
      'Claudio Andriani',
      'Quintetto'
    ],
    featured: false
  },
  {
    slug: 'quartetto-alcaplica-beethoven-2017',
    title: {
      en: 'Beethoven Quartetto, 1° tempo',
      it: 'Beethoven Quartetto, 1° tempo'
    },
    subtitle: {
      en: 'Quartetto Alcaplica performs Beethoven',
      it: 'Quartetto Alcaplica esegue Beethoven'
    },
    description: {
      en: 'Performance of Beethoven\'s quartet first movement by Quartetto Alcaplica.',
      it: 'Esecuzione del primo movimento del quartetto di Beethoven da parte del Quartetto Alcaplica.'
    },
    fullDescription: {
      en: 'Quartetto Alcaplica, composed of Pierluigi Camicia (piano), Carmelo Andriani (violin), Claudio Andriani (viola), and Vito Paternoster (cello), performs Beethoven\'s quartet first movement as part of the "Per l\'autunno delle Stagioni dell\'Agìmus" concert series presented by Giovanni Padovano Musical Initiatives Association.',
      it: 'Il Quartetto Alcaplica, composto da Pierluigi Camicia (pianoforte), Carmelo Andriani (violino), Claudio Andriani (viola) e Vito Paternoster (violoncello), esegue il primo movimento del quartetto di Beethoven come parte della rassegna "Per l\'autunno delle Stagioni dell\'Agìmus" presentata dall\'Associazione Giovanni Padovano Iniziative Musicali.'
    },
    type: 'concert',
    date: '2017-11-20',
    time: '21:00',
    location: {
      name: 'Agìmus Association',
      address: 'Associazione Giovanni Padovano Iniziative Musicali',
      city: 'Italy',
      country: 'Italy'
    },
    image: 'https://placehold.co/600x400/8B4513/FFFFFF?text=Quartetto+Alcaplica&font=playfair-display',
    ticketUrl: 'https://www.youtube.com/watch?v=QNGmuzDP48g',
    performers: [
      'Pierluigi Camicia (pianoforte)',
      'Carmelo Andriani (violino)',
      'Claudio Andriani (viola)',
      'Vito Paternoster (violoncello)'
    ],
    featured: false
  },
  {
    slug: 'volto-riscoperto-musica-2020',
    title: {
      en: 'Il volto riscoperto della Musica',
      it: 'Il volto riscoperto della Musica'
    },
    subtitle: {
      en: 'G.B. Vitali & Barabano - Finale',
      it: 'G.B. Vitali & Barabano - Finale'
    },
    description: {
      en: 'Baroque music concert featuring works by G.B. Vitali and Barabano.',
      it: 'Concerto di musica barocca con opere di G.B. Vitali e Barabano.'
    },
    fullDescription: {
      en: '"Il volto riscoperto della Musica" presents a concert featuring the finale of works by G.B. Vitali and Barabano, performed by Ensemble Italico Splendore. This performance explores the rediscovered aspects of baroque musical expression, showcasing the ensemble\'s dedication to historical performance practice.',
      it: '"Il volto riscoperto della Musica" presenta un concerto con il finale di opere di G.B. Vitali e Barabano, eseguito dall\'Ensemble Italico Splendore. Questa esibizione esplora gli aspetti riscoperti dell\'espressione musicale barocca, mostrando la dedizione dell\'ensemble alla prassi esecutiva storica.'
    },
    type: 'concert',
    date: '2020-01-15',
    time: '21:00',
    location: {
      name: 'Italy',
      address: 'Various venues in Italy',
      city: 'Italy',
      country: 'Italy'
    },
    image: '/events/2018-palazzoviceconte-matera/materia2018.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=mK_1AYnJj3E',
    performers: [
      'Ensemble Italico Splendore'
    ],
    featured: false
  },
  {
    slug: 'cardano-al-campo-2013',
    title: {
      en: 'Ensemble Italico Splendore',
      it: 'Ensemble Italico Splendore'
    },
    subtitle: {
      en: 'Chamber Music Concert with Marco Scorticati',
      it: 'Concerto di Musica da Camera con Marco Scorticati'
    },
    description: {
      en: 'Chamber music concert featuring Marco Scorticati on flute.',
      it: 'Concerto di musica da camera con Marco Scorticati al flauto.'
    },
    fullDescription: {
      en: 'A chamber music concert by Ensemble Italico Splendore featuring Marco Scorticati as flute soloist. The performance showcases the ensemble\'s expertise in baroque and classical repertoire, presenting intimate chamber works in the historic setting of Cardano al Campo.',
      it: 'Un concerto di musica da camera dell\'Ensemble Italico Splendore con Marco Scorticati come solista al flauto. L\'esibizione mostra l\'esperienza dell\'ensemble nel repertorio barocco e classico, presentando opere da camera intime nella storica cornice di Cardano al Campo.'
    },
    type: 'concert',
    date: '2013-03-08',
    time: '21:00',
    location: {
      name: 'Cardano al Campo',
      address: 'Cardano al Campo, Varese',
      city: 'Cardano al Campo',
      country: 'Italy'
    },
    image: '/events/2017-cardanoalcampo-italico/italicospendore-cardanoalcampo.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=dHmppVxy_A4',
    performers: [
      'Ensemble Italico Splendore',
      'Marco Scorticati (flute)'
    ],
    featured: false
  },
  {
    slug: 'ravenna-musica-2018',
    title: {
      en: 'La Verdi Barocca',
      it: 'La Verdi Barocca'
    },
    subtitle: {
      en: 'Ravenna Musica presents Baroque masterpieces',
      it: 'Ravenna Musica presenta capolavori barocchi'
    },
    description: {
      en: 'Baroque orchestra concert featuring Sonia Prina at Teatro Alighieri.',
      it: 'Concerto di orchestra barocca con Sonia Prina al Teatro Alighieri.'
    },
    fullDescription: {
      en: 'Ravenna Musica presents "La Verdi Barocca" featuring renowned contralto Sonia Prina at the historic Teatro Alighieri. This concert showcases baroque masterpieces performed by the specialized ensemble La Verdi Barocca, bringing authentic period performance practice to Ravenna\'s prestigious concert series.',
      it: 'Ravenna Musica presenta "La Verdi Barocca" con la celebre contralto Sonia Prina allo storico Teatro Alighieri. Questo concerto presenta capolavori barocchi eseguiti dall\'ensemble specializzato La Verdi Barocca, portando autentiche prassi esecutive di epoca alla prestigiosa serie concertistica di Ravenna.'
    },
    type: 'concert',
    date: '2018-03-22',
    time: '20:30',
    location: {
      name: 'Teatro Alighieri',
      address: 'Via Giosuè Carducci, 2, Ravenna',
      city: 'Ravenna',
      country: 'Italy'
    },
    image: '/events/2018-ravennamusica-soniaprina/prina.jpg',
    ticketUrl: 'https://www.ravennanotizie.it/2018/03/21/ravenna-musica-2018-il-22-marzo-al-teatro-alighieri-arriva-lorchestra-labarocca/38680/',
    performers: [
      'Sonia Prina (contralto)',
      'La Verdi Barocca'
    ],
    featured: true
  },
  {
    slug: 'violafest-catania-2025',
    title: {
      en: 'ViolaFest Catania 2025',
      it: 'ViolaFest Catania 2025'
    },
    subtitle: {
      en: '10th Edition of the Viola Festival',
      it: '10° Edizione del Festival della Viola'
    },
    description: {
      en: 'The 10th edition of ViolaFest Catania featuring the Quartetto di Viole di Alessandria.',
      it: 'La 10° edizione di ViolaFest Catania con il Quartetto di Viole di Alessandria.'
    },
    fullDescription: {
      en: 'ViolaFest Catania celebrates its 10th edition with a comprehensive program featuring the Quartetto di Viole di Alessandria and other viola ensembles, showcasing the versatility and beauty of the viola repertoire.',
      it: 'ViolaFest Catania celebra la sua 10° edizione con un programma completo che presenta il Quartetto di Viole di Alessandria e altri ensemble di viole, mostrando la versatilità e la bellezza del repertorio per viola.'
    },
    type: 'festival',
    date: '2025-11-01',
    time: '10:00',
    location: {
      name: 'Conservatorio di Catania',
      address: 'Via Santa Maria delle Grazie, Catania',
      city: 'Catania',
      country: 'Italy'
    },
    image: '/events/2017-academiadeisolinghi/claudioandriani.jpg',
    ticketUrl: 'https://www.conservatoriocatania.it/wp-content/uploads/2025/11/programma_violafest_2025.pdf',
    performers: [
      'Quartetto di Viole di Alessandria'
    ],
    featured: false
  },
  {
    slug: 'bach-sonatas-alessandria-2025',
    title: {
      en: 'J.S. Bach: 6 Sonatas for Violin and Harpsichord',
      it: 'J.S. Bach: 6 Sonate per Violino e Clavicembalo'
    },
    subtitle: {
      en: 'Baroque masterpieces performed on period instruments',
      it: 'Capolavori barocchi eseguiti con strumenti d\'epoca'
    },
    description: {
      en: 'A complete performance of Bach\'s six sonatas for violin and harpsichord.',
      it: 'Un\'esecuzione completa delle sei sonate di Bach per violino e clavicembalo.'
    },
    fullDescription: {
      en: 'A complete performance of J.S. Bach\'s six sonatas for violin and harpsichord, featuring Silvia De Rosso on violin and Daniele Boccaccio on harpsichord. This concert presents Bach\'s masterful writing for this intimate chamber combination.',
      it: 'Un\'esecuzione completa delle sei sonate di J.S. Bach per violino e clavicembalo, con Silvia De Rosso al violino e Daniele Boccaccio al clavicembalo. Questo concerto presenta la scrittura magistrale di Bach per questa combinazione da camera intima.'
    },
    type: 'concert',
    date: '2025-05-07',
    time: '20:30',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.conservatoriovivaldi.it/evento/7-maggio-2025-mercoledi/',
    performers: [
      'Silvia De Rosso (violin)',
      'Daniele Boccaccio (harpsichord)'
    ],
    featured: false
  },
  {
    slug: 'biber-rosenkranzsonaten-2025',
    title: {
      en: 'Biber: Rosenkranzsonaten (The Mystery Sonatas)',
      it: 'Biber: Rosenkranzsonaten (Le Sonate Mistero)'
    },
    subtitle: {
      en: 'Baroque violin masterpieces by Heinrich Biber',
      it: 'Capolavori barocchi per violino di Heinrich Biber'
    },
    description: {
      en: 'Performance of Biber\'s Mystery Sonatas with Il Cantiere di Orfeo.',
      it: 'Esecuzione delle Sonate Mistero di Biber con Il Cantiere di Orfeo.'
    },
    fullDescription: {
      en: 'Heinrich Biber\'s Rosenkranzsonaten (Mystery Sonatas) performed by Il Cantiere di Orfeo at the Church of San Lorenzo in Alessandria, directed by Claudio Andriani. These remarkable works from the 17th century feature innovative scordatura tuning and profound spiritual symbolism.',
      it: 'Le Rosenkranzsonaten (Sonate Mistero) di Heinrich Biber eseguite da Il Cantiere di Orfeo presso la Chiesa di San Lorenzo ad Alessandria, dirette da Claudio Andriani. Queste opere notevoli del XVII secolo presentano innovazioni di accordatura e profondo simbolismo spirituale.'
    },
    type: 'concert',
    date: '2025-03-15',
    time: '21:00',
    location: {
      name: 'Church of San Lorenzo',
      address: 'Piazza San Lorenzo, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://alessandria.today/2025/03/10/sabato-15-e-22-marzo-gli-appuntamenti-con-la-musica-barocca-in-san-lorenzo-comunicato-stampa/',
    performers: [
      'Il Cantiere di Orfeo',
      'Claudio Andriani (artistic director)'
    ],
    featured: false
  },
  {
    slug: 'bach-adventskantaten-2024',
    title: {
      en: 'J.S. Bach: Adventskantaten',
      it: 'J.S. Bach: Cantate d\'Avvento'
    },
    subtitle: {
      en: 'Bach cantatas for the Advent season',
      it: 'Cantate di Bach per la stagione d\'Avvento'
    },
    description: {
      en: 'Advent cantatas by J.S. Bach performed by Il Cantiere di Orfeo.',
      it: 'Cantate d\'avvento di J.S. Bach eseguite da Il Cantiere di Orfeo.'
    },
    fullDescription: {
      en: 'A performance of J.S. Bach\'s Advent cantatas (BWV 137, 147, 29) by Il Cantiere di Orfeo, featuring Daniele Boccaccio as director and Mirko Guadagnini as soloists preparer. This concert presents Bach\'s sacred music for the Advent season.',
      it: 'Un\'esecuzione delle cantate d\'avvento di J.S. Bach (BWV 137, 147, 29) da parte de Il Cantiere di Orfeo, con Daniele Boccaccio come direttore e Mirko Guadagnini come preparatore dei solisti. Questo concerto presenta la musica sacra di Bach per la stagione d\'Avvento.'
    },
    type: 'concert',
    date: '2024-12-08',
    time: '21:00',
    location: {
      name: 'Chiesa del Carmine',
      address: 'Piazza del Carmine, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=5Z9w5bVQREk',
    performers: [
      'Il Cantiere di Orfeo',
      'Daniele Boccaccio (director)',
      'Mirko Guadagnini (soloists preparer)'
    ],
    featured: false
  },
  {
    slug: 'buxtehude-membra-2024',
    title: {
      en: 'Membra Jesu Nostri (Buxtehude)',
      it: 'Membra Jesu Nostri (Buxtehude)'
    },
    subtitle: {
      en: 'Buxtehude\'s sacred cantatas',
      it: 'Cantate sacre di Buxtehude'
    },
    description: {
      en: 'Seven Easter cantatas by Dieterich Buxtehude.',
      it: 'Sette cantate pasquali di Dieterich Buxtehude.'
    },
    fullDescription: {
      en: 'A performance of Dieterich Buxtehude\'s "Membra Jesu Nostri," a cycle of seven cantatas meditating on the limbs of Christ on the cross. Performed by Il Cantiere di Orfeo with Juan Manuel Quintana directing and playing organ.',
      it: 'Un\'esecuzione di "Membra Jesu Nostri" di Dieterich Buxtehude, un ciclo di sette cantate che meditano sugli arti di Cristo sulla croce. Eseguito da Il Cantiere di Orfeo con Juan Manuel Quintana alla direzione e all\'organo.'
    },
    type: 'concert',
    date: '2024-03-16',
    time: '21:00',
    location: {
      name: 'Chiesa di Santa Maria del Carmine',
      address: 'Piazza del Carmine, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=gza4yGjL9g8',
    performers: [
      'Il Cantiere di Orfeo',
      'Juan Manuel Quintana (director, organ)'
    ],
    featured: false
  },
  {
    slug: 'monteverdi-orfeo-2022',
    title: {
      en: 'L\'Orfeo (Monteverdi)',
      it: 'L\'Orfeo (Monteverdi)'
    },
    subtitle: {
      en: 'Monteverdi\'s famous opera performed by early music specialists',
      it: 'L\'opera famosa di Monteverdi eseguita da specialisti di musica antica'
    },
    description: {
      en: 'Performance of Monteverdi\'s opera "L\'Orfeo" with early music ensemble.',
      it: 'Esecuzione dell\'opera "L\'Orfeo" di Monteverdi con ensemble di musica antica.'
    },
    fullDescription: {
      en: 'Claudio Monteverdi\'s "L\'Orfeo," considered one of the earliest operas, performed by the Interdipartimento di Musica Antica (IMA) as part of the Scatola Sonora XXV Festival. Featuring Sabino Manzo as director and Luca Valentino as regia.',
      it: '"L\'Orfeo" di Claudio Monteverdi, considerata una delle prime opere, eseguita dall\'Interdipartimento di Musica Antica (IMA) come parte del Festival Scatola Sonora XXV. Con Sabino Manzo come direttore e Luca Valentino come regia.'
    },
    type: 'opera',
    date: '2022-06-16',
    time: '21:00',
    location: {
      name: 'Chiesa di Santa Maria di Castello',
      address: 'Via Santa Maria di Castello, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=8QVmaKMBcEk',
    performers: [
      'Interdipartimento di Musica Antica (IMA)',
      'Sabino Manzo (director)',
      'Luca Valentino (regia)',
      'Evangelina Mascardi',
      'Mirko Guadagnini (musical preparer)',
      'Daniele Boccaccio',
      'Fernando De Luca',
      'Carolina Pace'
    ],
    featured: false
  },
  {
    slug: 'corelli-cafaro-2022',
    title: {
      en: 'Concerto di Pasqua - Corelli & Cafaro',
      it: 'Concerto di Pasqua - Corelli & Cafaro'
    },
    subtitle: {
      en: 'Easter concert with baroque orchestra',
      it: 'Concerto di Pasqua con orchestra barocca'
    },
    description: {
      en: 'Easter concert featuring Corelli\'s Concerto Grosso and Cafaro\'s Stabat Mater.',
      it: 'Concerto di Pasqua con il Concerto Grosso di Corelli e lo Stabat Mater di Cafaro.'
    },
    fullDescription: {
      en: 'An Easter concert featuring Arcangelo Corelli\'s Concerto Grosso No. 4, Op. 6 and Cafaro\'s Stabat Mater, performed by the baroque orchestra of the Conservatorio "A. Vivaldi" with choir and soloists.',
      it: 'Un concerto di Pasqua con il Concerto Grosso n. 4 op. 6 di Arcangelo Corelli e lo Stabat Mater di Cafaro, eseguito dall\'orchestra barocca del Conservatorio "A. Vivaldi" con coro e solisti.'
    },
    type: 'concert',
    date: '2022-04-11',
    time: '21:00',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=H9Bpg8s1cfs',
    performers: [
      'Orchestra barocca del Conservatorio "A. Vivaldi"',
      'Sabino Manzo (director)',
      'Anna Scolaro (soprano)',
      'Giulia Medicina (mezzosoprano)'
    ],
    featured: false
  },
  {
    slug: 'conservatorio-nov-2024',
    title: {
      en: 'I Mercoledì del Conservatorio',
      it: 'I Mercoledì del Conservatorio'
    },
    subtitle: {
      en: 'Conservatory Wednesday Concert Series',
      it: 'Rassegna del Conservatorio'
    },
    description: {
      en: 'Conservatory concert series featuring student and faculty performances.',
      it: 'Rassegna concertistica del conservatorio con esibizioni di studenti e docenti.'
    },
    fullDescription: {
      en: 'The "I Mercoledì del Conservatorio" series continues with performances by students and faculty of the Conservatorio "A. Vivaldi" in Alessandria, showcasing the educational institution\'s musical excellence.',
      it: 'La serie "I Mercoledì del Conservatorio" continua con esibizioni di studenti e docenti del Conservatorio "A. Vivaldi" di Alessandria, mostrando l\'eccellenza musicale dell\'istituzione educativa.',
    },
    type: 'concert',
    date: '2024-11-27',
    time: '20:30',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.alessandria24.com/2024/11/25/dal-27-novembre-ad-alessandria-tornano-i-mercoledi-del-conservatorio/',
    performers: [
      'Conservatorio "A. Vivaldi" Faculty and Students'
    ],
    featured: false
  },
  {
    slug: 'violafest-alessandria-2024-across',
    title: {
      en: 'Across',
      it: 'Across'
    },
    subtitle: {
      en: 'ViolaFest 2024 Performance',
      it: 'ViolaFest 2024 - Concerto'
    },
    description: {
      en: 'Contemporary viola piece performed at ViolaFest 2024.',
      it: 'Brano contemporaneo per viola eseguito al ViolaFest 2024.'
    },
    fullDescription: {
      en: 'Performance of "Across," a contemporary work for viola, as part of the ViolaFest 2024 at the Conservatorio "A. Vivaldi" in Alessandria. The festival featured new compositions and masterclasses for viola.',
      it: 'Esecuzione di "Across," un\'opera contemporanea per viola, come parte del ViolaFest 2024 al Conservatorio "A. Vivaldi" di Alessandria. Il festival ha presentato nuove composizioni e masterclass per viola.'
    },
    type: 'concert',
    date: '2024-10-24',
    time: '21:00',
    location: {
      name: 'Conservatorio "A. Vivaldi"',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    performers: [
      'Andrea Siano'
    ],
    featured: false
  },
  {
    slug: 'violafest-alessandria-2024-debbie-smile',
    title: {
      en: 'Debbie Smile',
      it: 'Debbie Smile'
    },
    subtitle: {
      en: 'ViolaFest 2024 Performance',
      it: 'ViolaFest 2024 - Concerto'
    },
    description: {
      en: 'Contemporary viola piece performed at ViolaFest 2024.',
      it: 'Brano contemporaneo per viola eseguito al ViolaFest 2024.'
    },
    fullDescription: {
      en: 'Performance of "Debbie Smile," a contemporary work for viola ensemble, featuring Eyal Bat, Ruggeri, and Roberto Ville as performers at the ViolaFest 2024.',
      it: 'Esecuzione di "Debbie Smile," un\'opera contemporanea per ensemble di viole, con Eyal Bat, Ruggeri e Roberto Ville come interpreti al ViolaFest 2024.'
    },
    type: 'concert',
    date: '2024-10-25',
    time: '21:00',
    location: {
      name: 'Conservatorio "A. Vivaldi"',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    performers: [
      'Eyal Bat',
      'Ruggeri',
      'Roberto Ville'
    ],
    featured: false
  },
  {
    slug: 'violafest-alessandria-2024-tango',
    title: {
      en: 'Tango',
      it: 'Tango'
    },
    subtitle: {
      en: 'ViolaFest 2024 Performance',
      it: 'ViolaFest 2024 - Concerto'
    },
    description: {
      en: 'Tango-inspired viola piece performed at ViolaFest 2024.',
      it: 'Brano per viola ispirato al tango eseguito al ViolaFest 2024.'
    },
    fullDescription: {
      en: 'Performance of "Tango," a contemporary work for viola featuring Umberto Galante at the ViolaFest 2024, showcasing the versatility of the viola in different musical styles.',
      it: 'Esecuzione di "Tango," un\'opera contemporanea per viola con Umberto Galante al ViolaFest 2024, mostrando la versatilità della viola in diversi stili musicali.'
    },
    type: 'concert',
    date: '2024-10-26',
    time: '21:00',
    location: {
      name: 'Conservatorio "A. Vivaldi"',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    performers: [
      'Umberto Galante'
    ],
    featured: false
  },
  {
    slug: 'conservatorio-maggio-2024',
    title: {
      en: 'I Mercoledì del Conservatorio',
      it: 'I Mercoledì del Conservatorio'
    },
    subtitle: {
      en: 'Conservatory Wednesday Concert Series',
      it: 'Rassegna del Conservatorio'
    },
    description: {
      en: 'Conservatory concert featuring Favali and Tchaikovsky works.',
      it: 'Concerto del conservatorio con opere di Favali e Tchaikovsky.'
    },
    fullDescription: {
      en: 'A concert from the "I Mercoledì del Conservatorio" series featuring Federico Favali\'s "Tankas" and Tchaikovsky\'s "Trio in A minor op.50," performed by Claudio Merlo (cello) and Ruta Stadalnykaite (piano) with student ensemble.',
      it: 'Un concerto della serie "I Mercoledì del Conservatorio" con "Tankas" di Federico Favali e il "Trio in la minore op.50" di Tchaikovsky, eseguito da Claudio Merlo (violoncello) e Ruta Stadalnykaite (pianoforte) con ensemble di studenti.'
    },
    type: 'concert',
    date: '2024-05-08',
    time: '20:30',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=-rFb4fcR8J8',
    performers: [
      'Claudio Merlo (cello)',
      'Ruta Stadalnykaite (piano)',
      'Student Ensemble'
    ],
    featured: false
  },
  {
    slug: 'fantasia-con-fuoco-2023',
    title: {
      en: 'Fantasia con Fuoco',
      it: 'Fantasia con Fuoco'
    },
    subtitle: {
      en: 'Violin and Harp Duo Concert',
      it: 'Concerto per Duo Violino e Arpa'
    },
    description: {
      en: 'Duo concert featuring violin and harp repertoire.',
      it: 'Concerto duo con repertorio per violino e arpa.'
    },
    fullDescription: {
      en: '"Fantasia con Fuoco" performed by the violin and harp duo "Andriani-Terzano" as part of the 32nd edition of "I Mercoledì del Conservatorio" series. Sara Terzano is a renowned harpist and composer, faculty member at the Conservatorio Vivaldi.',
      it: '"Fantasia con Fuoco" eseguito dal duo violino e arpa "Andriani-Terzano" come parte della 32° edizione della serie "I Mercoledì del Conservatorio". Sara Terzano è una celebre arpista e compositrice, docente del Conservatorio Vivaldi.'
    },
    type: 'concert',
    date: '2023-12-06',
    time: '17:00',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.ilmonferrato.it/notizia/VdcowSgZkkekgdjWT_6CkA/alessandria-auditorium-m-pittaluga-via-parma-1-alessandria-al-06-dicembre-2023-c-korjy8ygyrq',
    performers: [
      'Claudio Andriani (violin)',
      'Sara Terzano (harp)'
    ],
    featured: false
  },
  {
    slug: 'abendmusiken-2023',
    title: {
      en: 'Abendmusiken',
      it: 'Abendmusiken'
    },
    subtitle: {
      en: 'German Cantatas & Instrumental Music (16th-17th centuries)',
      it: 'Cantate tedesche e musica strumentale (XVI-XVII secolo)'
    },
    description: {
      en: 'Evening music featuring German Baroque cantatas and instrumental works.',
      it: 'Musica serale con cantate e opere strumentali barocche tedesche.'
    },
    fullDescription: {
      en: 'An evening of German Baroque music featuring cantatas and instrumental works from the 16th-17th centuries, performed by IMA-Interdipartimento di Musica Antica with Evangelina Mascardi as concert master and Dario Tabbia as choir director.',
      it: 'Una serata di musica barocca tedesca con cantate e opere strumentali dei secoli XVI-XVII, eseguita da IMA-Interdipartimento di Musica Antica con Evangelina Mascardi come concert master e Dario Tabbia come direttore del coro.'
    },
    type: 'concert',
    date: '2023-04-21',
    time: '20:30',
    location: {
      name: 'Tempio Valdese',
      address: 'Corso Vittorio Emanuele II, 23, Torino',
      city: 'Torino',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=pb8cuonZKRc',
    performers: [
      'IMA-Interdipartimento di Musica Antica',
      'Evangelina Mascardi (concert master)',
      'Dario Tabbia (choir director)',
      'Claudio Andriani',
      'Mirko Guadagnini',
      'Juan Manuel Quintana'
    ],
    featured: false
  },
  {
    slug: 'violafest-bolzano-2023-amor',
    title: {
      en: 'Amor, perché sì raro',
      it: 'Amor, perché sì raro'
    },
    subtitle: {
      en: 'ViolaFest Bolzano 2023',
      it: 'ViolaFest Bolzano 2023'
    },
    description: {
      en: 'Baroque viola piece performed at ViolaFest Bolzano.',
      it: 'Brano barocco per viola eseguito al ViolaFest di Bolzano.'
    },
    fullDescription: {
      en: 'Performance of "Amor, perché sì raro" by Quartetto di Viole di Alessandria at the ViolaFest in Bolzano, showcasing baroque repertoire for viola ensemble.',
      it: 'Esecuzione di "Amor, perché sì raro" del Quartetto di Viole di Alessandria al ViolaFest di Bolzano, mostrando il repertorio barocco per ensemble di viole.'
    },
    type: 'festival',
    date: '2023-04-01',
    time: '21:00',
    location: {
      name: 'ViolaFest Bolzano',
      address: 'Bolzano',
      city: 'Bolzano',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    performers: [
      'Quartetto di Viole di Alessandria'
    ],
    featured: false
  },
  {
    slug: 'violafest-bolzano-2023-sonata',
    title: {
      en: 'Sonata per viola e basso continuo in fa maggiore',
      it: 'Sonata per viola e basso continuo in fa maggiore'
    },
    subtitle: {
      en: 'ViolaFest Bolzano 2023',
      it: 'ViolaFest Bolzano 2023'
    },
    description: {
      en: 'Baroque viola sonata performed at ViolaFest Bolzano.',
      it: 'Sonata barocca per viola eseguita al ViolaFest di Bolzano.'
    },
    fullDescription: {
      en: 'Performance of a Baroque sonata for viola and basso continuo in F major by Enrico Lucchetti at the ViolaFest in Bolzano, featuring historical performance practice.',
      it: 'Esecuzione di una sonata barocca per viola e basso continuo in fa maggiore di Enrico Lucchetti al ViolaFest di Bolzano, con prassi esecutiva storica.'
    },
    type: 'festival',
    date: '2023-04-02',
    time: '21:00',
    location: {
      name: 'ViolaFest Bolzano',
      address: 'Bolzano',
      city: 'Bolzano',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://youtu.be/QqiiOcaXDLE?si=uzUf-K7aNdJZwGkU&t=2820',
    performers: [
      'Enrico Lucchetti'
    ],
    featured: false
  },
  {
    slug: 'conservatorio-xxx1-2022',
    title: {
      en: 'Mercoledi del Conservatorio XXXI',
      it: 'Mercoledi del Conservatorio XXXI'
    },
    subtitle: {
      en: 'Conservatory Wednesday Concert Series',
      it: 'Rassegna del Conservatorio'
    },
    description: {
      en: 'Conservatory concert featuring Brahms and Zemlinsky.',
      it: 'Concerto del conservatorio con Brahms e Zemlinsky.'
    },
    fullDescription: {
      en: 'A concert from the "I Mercoledì del Conservatorio" series featuring works by Brahms and Zemlinsky, performed by Cristina Nicolini and Claudio Merlo.',
      it: 'Un concerto della serie "I Mercoledì del Conservatorio" con opere di Brahms e Zemlinsky, eseguito da Cristina Nicolini e Claudio Merlo.'
    },
    type: 'concert',
    date: '2022-12-07',
    time: '20:30',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=qr3eWz5ybZY',
    performers: [
      'Cristina Nicolini',
      'Claudio Merlo'
    ],
    featured: false
  },
  {
    slug: 'violafest-bari-2022',
    title: {
      en: 'Il Contraltare',
      it: 'Il Contraltare'
    },
    subtitle: {
      en: 'ViolaFest Bari 2022',
      it: 'ViolaFest Bari 2022'
    },
    description: {
      en: 'Viola ensemble performance at ViolaFest Bari.',
      it: 'Esibizione di ensemble di viole al ViolaFest di Bari.'
    },
    fullDescription: {
      en: 'Performance by the Il Contraltare viola ensemble featuring Fulvia Corazza, Elena Saccomandi, and Gerardo Vitale at the ViolaFest in Bari, showcasing contemporary viola ensemble repertoire.',
      it: 'Esecuzione dell\'ensemble di viole Il Contraltare con Fulvia Corazza, Elena Saccomandi e Gerardo Vitale al ViolaFest di Bari, mostrando il repertorio contemporaneo per ensemble di viole.'
    },
    type: 'festival',
    date: '2022-10-01',
    time: '21:00',
    location: {
      name: 'ViolaFest Bari',
      address: 'Bari',
      city: 'Bari',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://associazioneitalianadellaviola.wordpress.com/wp-content/uploads/2022/10/violafest-2022-libretto-ufficiale-1-1.pdf',
    performers: [
      'Il Contraltare viola ensemble',
      'Fulvia Corazza',
      'Elena Saccomandi',
      'Gerardo Vitale'
    ],
    featured: false
  },
  {
    slug: 'campagnoli-capricci-2020',
    title: {
      en: 'I Capricci di Bartolomeo Campagnoli 35-41',
      it: 'I Capricci di Bartolomeo Campagnoli 35-41'
    },
    subtitle: {
      en: 'ViolaFest Remote Performance',
      it: 'ViolaFest - Esibizione da remoto'
    },
    description: {
      en: 'Remote performance of Campagnoli viola caprices.',
      it: 'Esecuzione da remoto dei capricci per viola di Campagnoli.'
    },
    fullDescription: {
      en: 'A remote performance of Bartolomeo Campagnoli\'s Caprices Nos. 35-41 for viola, part of the ViolaFest series adapted for online presentation during the pandemic period.',
      it: 'Un\'esecuzione da remoto dei Caprici n. 35-41 di Bartolomeo Campagnoli per viola, parte della serie ViolaFest adattata per la presentazione online durante il periodo pandemico.'
    },
    type: 'festival',
    date: '2020-06-15',
    time: '18:00',
    location: {
      name: 'Remote Performance',
      address: 'Online',
      city: 'Remote',
      country: 'Online'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=1XJr0-M-vR8',
    performers: [
      'Claudio Andriani'
    ],
    featured: false
  },
  {
    slug: 'viola-fest-remote-2020',
    title: {
      en: 'ViolaFest Remote',
      it: 'ViolaFest Remote'
    },
    subtitle: {
      en: 'I Capricci di Bartolomeo Campagnoli 35-41',
      it: 'I Capricci di Bartolomeo Campagnoli 35-41'
    },
    description: {
      en: 'Remote ViolaFest performance featuring Bartolomeo Campagnoli capriccios.',
      it: 'Esecuzione ViolaFest remota con i capricci di Bartolomeo Campagnoli.'
    },
    fullDescription: {
      en: 'A remote ViolaFest presentation featuring Bartolomeo Campagnoli\'s capriccios 35-41, presented online as part of the festival\'s digital programming during the remote period.',
      it: 'Una presentazione ViolaFest remota con i capricci 35-41 di Bartolomeo Campagnoli, presentata online come parte della programmazione digitale del festival durante il periodo remoto.'
    },
    type: 'festival',
    date: '2020-01-01',
    time: '19:00',
    location: {
      name: 'Remote',
      address: 'Online Event',
      city: 'Remote',
      country: 'Online'
    },
    image: 'https://placehold.co/600x400/6366F1/FFFFFF?text=ViolaFest+Remote&font=playfair-display',
    ticketUrl: 'https://www.youtube.com/watch?v=1XJr0-M-vR8',
    performers: [
      'Claudio Andriani'
    ],
    featured: false
  },
  {
    slug: 'festa-musica-bologna-2020',
    title: {
      en: 'Festa della Musica',
      it: 'Festa della Musica'
    },
    subtitle: {
      en: 'Music Festival at San Colombano',
      it: 'Festival musicale a San Colombano'
    },
    description: {
      en: 'Music festival performance by Italico Splendore.',
      it: 'Esibizione festival musicale di Italico Splendore.'
    },
    fullDescription: {
      en: 'Performance by Italico Splendore at the Festa della Musica held at Musei degli Strumenti di San Colombano in Bologna, featuring Rosita, Alessandro Andriani, and Domenico.',
      it: 'Esecuzione di Italico Splendore alla Festa della Musica tenuta presso i Musei degli Strumenti di San Colombano a Bologna, con Rosita, Alessandro Andriani e Domenico.'
    },
    type: 'festival',
    date: '2020-09-26',
    time: '18:00',
    location: {
      name: 'Musei degli Strumenti di San Colombano',
      address: 'Via Collegio di Spagna, 9, Bologna',
      city: 'Bologna',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://genusbononiae.it/eventi/festa-della-musica-26-e-27-settembre-2020/ https://www.eventbrite.it/e/biglietti-festa-della-musica-concerto-italico-splendore-120509634561',
    performers: [
      'Italico Splendore',
      'Rosita',
      'Alessandro Andriani',
      'Domenico'
    ],
    featured: false
  },
  {
    slug: 'volto-riscoperto-2019',
    title: {
      en: 'Il Volto Riscoperto della Musica - Stabat Mater',
      it: 'Il Volto Riscoperto della Musica - Stabat Mater'
    },
    subtitle: {
      en: '14th Edition - Baroque Music Series Opening Concert',
      it: '14ª Edizione - Concerto di apertura della rassegna di musica barocca'
    },
    description: {
      en: 'Opening concert of the 14th edition of "Il Volto Riscoperto della Musica" baroque music series featuring Pergolesi\'s Stabat Mater.',
      it: 'Concerto di apertura della 14ª edizione de "Il Volto Riscoperto della Musica" con lo Stabat Mater di Pergolesi.'
    },
    fullDescription: {
      en: 'The 14th edition of "Il Volto Riscoperto della Musica" baroque music series opens with Pergolesi\'s Stabat Mater at the Church of Sant\'Anastasio in Cardano al Campo. This year\'s edition focuses on Giuseppina Strepponi, the renowned soprano and Verdi\'s companion. The concert features the extraordinary ensemble Italico Splendore accompanying soprano Graziana Palazzo and mezzo-soprano Arianna Rinaldi. Free admission concert.',
      it: 'La 14ª edizione de "Il Volto Riscoperto della Musica" si apre con lo Stabat Mater di Pergolesi nella chiesa di Sant\'Anastasio a Cardano al Campo. Questa edizione è dedicata a Giuseppina Strepponi, soprano lodigiana e compagna di Giuseppe Verdi. Il concerto presenta lo straordinario ensemble Italico Splendore che accompagna il soprano Graziana Palazzo e la mezzosoprano Arianna Rinaldi. Concerto ad ingresso libero.'
    },
    type: 'concert',
    date: '2019-01-19',
    time: '21:00',
    location: {
      name: 'Chiesa di Sant\'Anastasio',
      address: 'Chiesa di Sant\'Anastasio, Cardano al Campo',
      city: 'Cardano al Campo',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.malpensa24.it/concerti-musica-cardano-stabat-mater-riapre-rassegna-barocca',
    performers: [
      'Italico Splendore',
      'Graziana Palazzo (soprano)',
      'Arianna Rinaldi (mezzo-soprano)'
    ],
    featured: false
  },
  {
    slug: 'violafest-siena-2019',
    title: {
      en: 'Stravinsky',
      it: 'Stravinsky'
    },
    subtitle: {
      en: 'ViolaFest Siena 2019',
      it: 'ViolaFest Siena 2019'
    },
    description: {
      en: 'Stravinsky performance at ViolaFest Siena.',
      it: 'Esecuzione di Stravinsky al ViolaFest di Siena.'
    },
    fullDescription: {
      en: 'A performance of works by Igor Stravinsky at the ViolaFest in Siena, showcasing contemporary repertoire for viola ensemble.',
      it: 'Un\'esecuzione di opere di Igor Stravinsky al ViolaFest di Siena, mostrando il repertorio contemporaneo per ensemble di viole.'
    },
    type: 'festival',
    date: '2019-07-15',
    time: '21:00',
    location: {
      name: 'ViolaFest Siena',
      address: 'Siena',
      city: 'Siena',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: '#',
    performers: [
      'Quartetto di Viole di Alessandria'
    ],
    featured: false
  },
  {
    slug: 'violafest-cremona-2018',
    title: {
      en: 'ViolaFest Cremona 2018',
      it: 'ViolaFest Cremona 2018'
    },
    subtitle: {
      en: 'Viola Festival Performance',
      it: 'Esibizione Festival della Viola'
    },
    description: {
      en: 'Viola performance at ViolaFest in Cremona.',
      it: 'Esecuzione di viola al ViolaFest di Cremona.'
    },
    fullDescription: {
      en: 'Performance at the ViolaFest in Cremona, the city famous for violin making and string instrument tradition.',
      it: 'Esecuzione al ViolaFest di Cremona, la città famosa per la liuteria e la tradizione degli strumenti ad arco.'
    },
    type: 'festival',
    date: '2018-09-20',
    time: '21:00',
    location: {
      name: 'ViolaFest Cremona',
      address: 'Cremona',
      city: 'Cremona',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.youtube.com/watch?v=75o_zqJMtSo',
    performers: [
      'Claudio Andriani'
    ],
    featured: false
  },
  {
    slug: 'concerto-pasqua-2018',
    title: {
      en: 'Concerto di Pasqua',
      it: 'Concerto di Pasqua'
    },
    subtitle: {
      en: 'Easter Concert',
      it: 'Concerto di Pasqua'
    },
    description: {
      en: 'Easter concert performance.',
      it: 'Concerto pasquale.'
    },
    fullDescription: {
      en: 'An Easter concert performance by Academi dei Solinghi directed by Angelo Manzoti at the Church of San Domenico in Alessandria.',
      it: 'Un concerto pasquale eseguito dall\'Accademi dei Solinghi diretto da Angelo Manzoti presso la Chiesa di San Domenico ad Alessandria.'
    },
    type: 'concert',
    date: '2018-04-01',
    time: '21:00',
    location: {
      name: 'Chiesa di San Domenico',
      address: 'Via San Domenico, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2018-pasqua-accademiadeisolinghi/pasqua2018.jpg',
    performers: [
      'Academi dei Solinghi',
      'Angelo Manzoti (director)'
    ],
    featured: false
  },
  {
    slug: 'quartetto-alcapicla-2018',
    title: {
      en: 'Quartetto Alcapicla Performance',
      it: 'Esibizione Quartetto Alcapicla'
    },
    subtitle: {
      en: 'Chamber Music Performance',
      it: 'Esibizione di Musica da Camera'
    },
    description: {
      en: 'Chamber music performance by Quartetto Alcapicla.',
      it: 'Esibizione di musica da camera del Quartetto Alcapicla.'
    },
    fullDescription: {
      en: 'A chamber music performance by the Quartetto Alcapicla ensemble in Lecce.',
      it: 'Un\'esibizione di musica da camera dell\'ensemble Quartetto Alcapicla a Lecce.'
    },
    type: 'concert',
    date: '2018-06-15',
    time: '21:00',
    location: {
      name: 'Lecce',
      address: 'Lecce',
      city: 'Lecce',
      country: 'Italy'
    },
    image: '/events/2017-lecce-alcapicla/alcapicla.jpg',
    performers: [
      'Quartetto Alcapicla'
    ],
    featured: false
  },
  {
    slug: 'trio-nigun-besazio-2018',
    title: {
      en: 'Luoghi da ascoltare',
      it: 'Luoghi da ascoltare'
    },
    subtitle: {
      en: 'Places to Listen - Chamber Music',
      it: 'Luoghi da ascoltare - Musica da camera'
    },
    description: {
      en: 'Chamber music concert in Besazio.',
      it: 'Concerto di musica da camera a Besazio.'
    },
    fullDescription: {
      en: 'A chamber music concert titled "Luoghi da ascoltare" (Places to Listen) featuring the Trio Nigun with Roberto Villa and Tehilla Meller in Besazio.',
      it: 'Un concerto di musica da camera intitolato "Luoghi da ascoltare" con il Trio Nigun formato da Roberto Villa e Tehilla Meller a Besazio.'
    },
    type: 'concert',
    date: '2018-07-20',
    time: '21:00',
    location: {
      name: 'Besazio',
      address: 'Besazio',
      city: 'Besazio',
      country: 'Italy'
    },
    image: '/ensemble/nigun/trionigun.jpg',
    performers: [
      'Trio Nigun',
      'Roberto Villa',
      'Tehilla Meller'
    ],
    featured: false
  },
  {
    slug: 'trio-nigun-varese-2018',
    title: {
      en: 'Trio Nigun Performance',
      it: 'Esibizione Trio Nigun'
    },
    subtitle: {
      en: 'Chamber Music Performance',
      it: 'Esibizione di Musica da Camera'
    },
    description: {
      en: 'Chamber music concert in Varese.',
      it: 'Concerto di musica da camera a Varese.'
    },
    fullDescription: {
      en: 'A chamber music concert by Trio Nigun featuring Roberto Villa and Tehilla Meller in Varese.',
      it: 'Un concerto di musica da camera del Trio Nigun con Roberto Villa e Tehilla Meller a Varese.'
    },
    type: 'concert',
    date: '2018-09-15',
    time: '21:00',
    location: {
      name: 'Varese',
      address: 'Varese',
      city: 'Varese',
      country: 'Italy'
    },
    image: '/events/2017-varese/varese2017.jpg',
    performers: [
      'Trio Nigun',
      'Roberto Villa',
      'Tehilla Meller'
    ],
    featured: false
  },
  {
    slug: 'haydn-beethoven-2017',
    title: {
      en: 'Haydn and Beethoven',
      it: 'Haydn e Beethoven'
    },
    subtitle: {
      en: 'Classical Chamber Music',
      it: 'Musica da Camera Classica'
    },
    description: {
      en: 'Chamber music featuring Haydn and Beethoven works.',
      it: 'Musica da camera con opere di Haydn e Beethoven.'
    },
    fullDescription: {
      en: 'A chamber music concert featuring works by Joseph Haydn and Ludwig van Beethoven, performed by Roberto Villa in Varese.',
      it: 'Un concerto di musica da camera con opere di Joseph Haydn e Ludwig van Beethoven, eseguito da Roberto Villa a Varese.'
    },
    type: 'concert',
    date: '2017-10-20',
    time: '21:00',
    location: {
      name: 'Varese',
      address: 'Varese',
      city: 'Varese',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    performers: [
      'Roberto Villa'
    ],
    featured: false
  },
  {
    slug: 'quattro-stagioni-golf-2017',
    title: {
      en: 'The Four Seasons',
      it: 'Le Quattro Stagioni'
    },
    subtitle: {
      en: 'Vivaldi\'s Four Seasons',
      it: 'Le Quattro Stagioni di Vivaldi'
    },
    description: {
      en: 'Performance of Vivaldi\'s Four Seasons.',
      it: 'Esecuzione delle Quattro Stagioni di Vivaldi.'
    },
    fullDescription: {
      en: 'A performance of Antonio Vivaldi\'s "The Four Seasons" by Italico Splendore at a private event at the Golf Club Torino.',
      it: 'Un\'esecuzione de "Le Quattro Stagioni" di Antonio Vivaldi da parte di Italico Splendore a un evento privato al Golf Club Torino.'
    },
    type: 'concert',
    date: '2017-06-10',
    time: '20:00',
    location: {
      name: 'Golf Club Torino',
      address: 'Turin',
      city: 'Turin',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    performers: [
      'Italico Splendore'
    ],
    featured: false
  },
  {
    slug: 'quattro-stagioni-accademia-2017',
    title: {
      en: 'The Four Seasons',
      it: 'Le Quattro Stagioni'
    },
    subtitle: {
      en: 'Vivaldi\'s Four Seasons',
      it: 'Le Quattro Stagioni di Vivaldi'
    },
    description: {
      en: 'Performance of Vivaldi\'s Four Seasons.',
      it: 'Esecuzione delle Quattro Stagioni di Vivaldi.'
    },
    fullDescription: {
      en: 'A performance of Antonio Vivaldi\'s "The Four Seasons" by Academia dei Solinghi.',
      it: 'Un\'esecuzione de "Le Quattro Stagioni" di Antonio Vivaldi da parte dell\'Accademia dei Solinghi.'
    },
    type: 'concert',
    date: '2017-08-15',
    time: '21:00',
    location: {
      name: 'Alessandria',
      address: 'Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-academiadeisolinghi/claudioandriani.jpg',
    performers: [
      'Academia dei Solinghi'
    ],
    featured: false
  },
  {
    slug: 'italico-splendore-cardano-2017',
    title: {
      en: 'Italico Splendore Concert',
      it: 'Concerto Italico Splendore'
    },
    subtitle: {
      en: 'Early Music Ensemble Performance',
      it: 'Esibizione Ensemble Musica Antica'
    },
    description: {
      en: 'Early music concert by Italico Splendore.',
      it: 'Concerto di musica antica di Italico Splendore.'
    },
    fullDescription: {
      en: 'A concert by the early music ensemble Italico Splendore in Cardano al Campo, featuring their historically informed performances on period instruments.',
      it: 'Un concerto dell\'ensemble di musica antica Italico Splendore a Cardano al Campo, con le loro esibizioni storicamente informate su strumenti d\'epoca.'
    },
    type: 'concert',
    date: '2017-05-20',
    time: '21:00',
    location: {
      name: 'Cardano al Campo',
      address: 'Cardano al Campo',
      city: 'Cardano al Campo',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    performers: [
      'Italico Splendore'
    ],
    featured: false
  },
  {
    slug: 'italico-splendore-turin-2017',
    title: {
      en: 'Italico Splendore Concert',
      it: 'Concerto Italico Splendore'
    },
    subtitle: {
      en: 'Early Music Ensemble Performance',
      it: 'Esibizione Ensemble Musica Antica'
    },
    description: {
      en: 'Early music concert by Italico Splendore.',
      it: 'Concerto di musica antica di Italico Splendore.'
    },
    fullDescription: {
      en: 'A concert by the early music ensemble Italico Splendore in Turin, continuing their mission to rediscover and perform rarely heard Baroque and Classical repertoire.',
      it: 'Un concerto dell\'ensemble di musica antica Italico Splendore a Torino, continuando la loro missione di riscoprire ed eseguire repertorio barocco e classico raramente ascoltato.'
    },
    type: 'concert',
    date: '2017-07-15',
    time: '21:00',
    location: {
      name: 'Turin',
      address: 'Turin',
      city: 'Turin',
      country: 'Italy'
    },
    image: '/events/2017-torino-italico/italico-torino.jpg',
    performers: [
      'Italico Splendore'
    ],
    featured: false
  },
  {
    slug: 'grandezze-meraviglie-2017',
    title: {
      en: 'Grandezze e Meraviglie',
      it: 'Grandezze e Meraviglie'
    },
    subtitle: {
      en: 'Grandeur and Marvels',
      it: 'Grandezze e Meraviglie'
    },
    description: {
      en: 'Performance of works by Giovanni Battista Vitali.',
      it: 'Esecuzione di opere di Giovanni Battista Vitali.'
    },
    fullDescription: {
      en: 'A concert titled "Grandezze e Meraviglie" featuring works by Giovanni Battista Vitali, performed by Italico Splendore at the Church of San Pietro in Modena.',
      it: 'Un concerto intitolato "Grandezze e Meraviglie" con opere di Giovanni Battista Vitali, eseguito da Italico Splendore presso la Chiesa di San Pietro a Modena.'
    },
    type: 'concert',
    date: '2017-11-25',
    time: '21:00',
    location: {
      name: 'Chiesa di San Pietro',
      address: 'Via San Pietro, Modena',
      city: 'Modena',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    gallery: [
      '/events/2017-modena-italico/slideshow/DSCN1489.JPG',
      '/events/2017-modena-italico/slideshow/DSCN1567.JPG',
      '/events/2017-modena-italico/slideshow/DSCN1577.JPG',
      '/events/2017-modena-italico/slideshow/DSCN1656.JPG',
      '/events/2017-modena-italico/slideshow/DSCN1661.JPG',
      '/events/2017-modena-italico/slideshow/DSCN1691.JPG'
    ],
    performers: [
      'Italico Splendore',
      'Giovanni Battista Vitali (composer)'
    ],
    featured: false
  },
  {
    slug: 'mysterium-festival-2017',
    title: {
      en: 'Mysterium Festival',
      it: 'Mysterium Festival'
    },
    subtitle: {
      en: 'John Rutter - Music by John Rutter',
      it: 'John Rutter - Musiche di John Rutter'
    },
    description: {
      en: 'Mysterium Festival featuring works by John Rutter with choir and orchestra.',
      it: 'Mysterium Festival con opere di John Rutter con coro e orchestra.'
    },
    fullDescription: {
      en: 'Mysterium Festival presents concerts featuring the music of John Rutter. The festival includes multiple performances: one in Matera at the Cathedral of Madonna della Bruna and Sant\'Eustachio with John Rutter conducting, Coro Giovanile Pugliese, L.A. Chorus, and Orchestra della Magna Grecia; and another performance in Taranto featuring Claudio Andriani on violin. Both events showcase contemporary choral and orchestral works in prestigious Italian venues.',
      it: 'Il Mysterium Festival presenta concerti con le musiche di John Rutter. Il festival include più esibizioni: una a Matera nella Cattedrale della Madonna della Bruna e di Sant\'Eustachio con John Rutter che dirige, il Coro Giovanile Pugliese, L.A. Chorus e l\'Orchestra della Magna Grecia; e un\'altra esibizione a Taranto con Claudio Andriani al violino. Entrambi gli eventi mostrano opere corali e orchestrali contemporanee in prestigiosi venue italiani.'
    },
    type: 'festival',
    date: '2017-03-25',
    time: '20:00',
    location: {
      name: 'Cattedrale della Madonna della Bruna e di Sant\'Eustachio',
      address: 'Cattedrale della Madonna della Bruna e di Sant\'Eustachio, Matera',
      city: 'Matera',
      country: 'Italy'
    },
    image: '/events/2017-taranto-mysterium/andriani-rutter.jpg',
    gallery: [
      '/events/2017-taranto-mysterium/slideshow/IMG_20170322_213003.jpg',
      '/events/2017-taranto-mysterium/slideshow/IMG_20170323_200228.jpg',
      '/events/2017-taranto-mysterium/slideshow/IMG_20170324_215141.jpg',
      '/events/2017-taranto-mysterium/slideshow/IMG_20170325_203844.jpg'
    ],
    performers: [
      'John Rutter (conductor)',
      'Claudio Andriani',
      'Coro Giovanile Pugliese',
      'L.A. Chorus',
      'Orchestra della Magna Grecia'
    ],
    featured: false
  },
  {
    slug: 'bach-brandenburg-2016',
    title: {
      en: 'Bach Brandenburg Concertos',
      it: 'Concerti Brandeburghesi di Bach'
    },
    subtitle: {
      en: 'Novus Spiritum Anticum Performance',
      it: 'Esibizione Novus Spiritum Anticum'
    },
    description: {
      en: 'Bach Brandenburg Concert No. 4 performance.',
      it: 'Concerto Brandeburghese n. 4 di Bach.'
    },
    fullDescription: {
      en: 'A performance of Bach\'s Brandenburg Concert No. 4 by Novus Spiritum Anticum in Karlsruhe, Germany, showcasing Baroque music in an international context.',
      it: 'Un\'esecuzione del Concerto Brandeburghese n. 4 di Bach da parte di Novus Spiritum Anticum a Karlsruhe, Germania, mostrando musica barocca in un contesto internazionale.'
    },
    type: 'concert',
    date: '2016-06-15',
    time: '20:00',
    location: {
      name: '',
      address: '',
      city: 'Karlsruhe',
      country: 'Germany'
    },
    image: '/events/2016-novusspiritumanticum-karlsruhe/tehilaclaudio.jpg',
    performers: [
      'Novus Spiritum Anticum'
    ],
    featured: false
  },
  {
    slug: 'musica-in-villa-2016',
    title: {
      en: 'Musica in Villa',
      it: 'Musica in Villa'
    },
    subtitle: {
      en: 'Chamber Music in Villa Setting',
      it: 'Musica da Camera in Villa'
    },
    description: {
      en: 'Chamber music concert in villa setting.',
      it: 'Concerto di musica da camera in villa.'
    },
    fullDescription: {
      en: 'A chamber music concert titled "Musica in Villa" featuring Tehila Meller, Alessandro Andriani, Fabio Eravasi, Maria Vittoria Carosi, and Elisabetta, performed by Italico Splendore.',
      it: 'Un concerto di musica da camera intitolato "Musica in Villa" con Tehila Meller, Alessandro Andriani, Fabio Eravasi, Maria Vittoria Carosi ed Elisabetta, eseguito da Italico Splendore.'
    },
    type: 'concert',
    date: '2016-07-20',
    time: '21:00',
    location: {
      name: 'Auditorium Civico Liceo Musicale "R.Malipiero"',
      address: 'Via Garibaldi 4',
      city: 'Varese',
      country: 'Italy'
    },
    image: 'https://placehold.co/600x400/2E8B57/FFFFFF?text=Musica+in+Villa&font=playfair-display',
    ticketUrl: '[Italico Splendore YouTube Channel]',
    performers: [
      'Italico Splendore',
      'Tehila Meller',
      'Alessandro Andriani',
      'Fabio Eravasi',
      'Maria Vittoria Carosi',
      'Elisabetta'
    ],
    featured: false
  },
  {
    slug: 'viola-concerto-finland-2012',
    title: {
      en: 'Viola Concerto',
      it: 'Concerto per Viola'
    },
    subtitle: {
      en: 'Finnish Viola Society Performance',
      it: 'Esibizione Finnish Viola Society'
    },
    description: {
      en: 'Performance of viola concerto by H. Puukko.',
      it: 'Esecuzione di concerto per viola di H. Puukko.'
    },
    fullDescription: {
      en: 'A performance of a viola concerto composed by H. Puukko, presented by the Finnish Viola Society in Kouvola, Finland.',
      it: 'Un\'esecuzione di un concerto per viola composto da H. Puukko, presentato dalla Finnish Viola Society a Kouvola, Finlandia.'
    },
    type: 'concert',
    date: '2012-06-15',
    time: '19:00',
    location: {
      name: 'Kouvola',
      address: 'Kouvola',
      city: 'Kouvola',
      country: 'Finland'
    },
    image: 'https://placehold.co/600x400/FFFFFF/003399?text=Viola+Concerto&font=playfair-display',
    ticketUrl: '[Finnish Viola Society Archive]',
    performers: [
      'Claudio Andriani',
      'Finnish Viola Society'
    ],
    featured: false
  },
  {
    slug: 'palazzo-barolo-1998',
    title: {
      en: 'Palazzo Barolo Concert',
      it: 'Concerto Palazzo Barolo'
    },
    subtitle: {
      en: 'Historic Venue Performance',
      it: 'Esibizione in Venue Storico'
    },
    description: {
      en: 'Concert at historic Palazzo Barolo.',
      it: 'Concerto allo storico Palazzo Barolo.'
    },
    fullDescription: {
      en: 'A concert performance at the historic Palazzo Barolo in Turin, showcasing music in an elegant historic setting.',
      it: 'Un concerto presso lo storico Palazzo Barolo a Torino, mostrando musica in un ambiente storico ed elegante.'
    },
    type: 'concert',
    date: '1998-06-20',
    time: '21:00',
    location: {
      name: 'Palazzo Barolo',
      address: 'Via delle Orfane, 7, Torino',
      city: 'Turin',
      country: 'Italy'
    },
    image: 'https://placehold.co/600x400/8B4513/FFFFFF?text=Palazzo+Barolo&font=playfair-display',
    performers: [
      'Claudio Andriani'
    ],
    featured: false
  },
  {
    slug: 'cantiere-orfeo-monteverdi-2024',
    title: {
      en: 'Monteverdi Madrigals',
      it: 'Madrigali di Monteverdi'
    },
    subtitle: {
      en: 'I Madrigalisti di Intende Voci & Il Cantiere di Orfeo',
      it: 'I Madrigalisti di Intende Voci & Il Cantiere di Orfeo'
    },
    description: {
      en: 'Monteverdi madrigals performed at Festival "Le Vie del Barocco" in Genoa.',
      it: 'Madrigali di Monteverdi eseguiti al Festival "Le Vie del Barocco" a Genova.'
    },
    fullDescription: {
      en: 'I Madrigalisti di Intende Voci and Ensemble vocale e strumentale Il Cantiere di Orfeo present a selection of Monteverdi madrigals from Books I-VII and Tirsi e Clori at the Monastero di Santa Chiara in Genoa, as part of the 31st Festival "Le Vie del Barocco".',
      it: 'I Madrigalisti di Intende Voci e Ensemble vocale e strumentale Il Cantiere di Orfeo presentano una selezione di madrigali di Monteverdi dai libri I-VII e Tirsi e Clori al Monastero di Santa Chiara a Genova, come parte del 31° Festival "Le Vie del Barocco".'
    },
    type: 'concert',
    date: '2024-10-27',
    time: '17:00',
    location: {
      name: 'Monastero di Santa Chiara',
      address: 'Genoa',
      city: 'Genoa',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://collegiumpromusica.com/madrigalisti-intende-voci-ensemble-il-cantiere-di-orfeo/',
    performers: [
      'I Madrigalisti di Intende Voci',
      'Il Cantiere di Orfeo',
      'Mirko Cristiano Guadagnini (maestro di concerto)'
    ],
    featured: false
  },
  {
    slug: 'cantiere-orfeo-italia-germania-2024',
    title: {
      en: 'Italia e Germania a confronto',
      it: 'Italia e Germania a confronto'
    },
    subtitle: {
      en: 'With Fabio Biondi',
      it: 'Con Fabio Biondi'
    },
    description: {
      en: 'Concert comparing Italian and German Baroque music.',
      it: 'Concerto che confronta la musica barocca italiana e tedesca.'
    },
    fullDescription: {
      en: 'Opening concert of Il Cantiere di Orfeo series featuring Fabio Biondi, comparing Italian and German Baroque traditions at Auditorium Pittaluga in Alessandria.',
      it: 'Concerto inaugurale della serie Il Cantiere di Orfeo con Fabio Biondi, che confronta le tradizioni barocche italiana e tedesca all\'Auditorium Pittaluga di Alessandria.'
    },
    type: 'concert',
    date: '2024-01-22',
    time: '21:00',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://radiogold.it/news-alessandria/365124-cantiere-orfeo-conservatorio-alessandria-concerti/',
    performers: [
      'Il Cantiere di Orfeo',
      'Fabio Biondi'
    ],
    featured: false
  },
  {
    slug: 'cantiere-orfeo-liuto-galante-2024',
    title: {
      en: 'Il liuto galante',
      it: 'Il liuto galante'
    },
    subtitle: {
      en: 'With Robert Barto (lute)',
      it: 'Con Robert Barto (liuto)'
    },
    description: {
      en: 'Lute recital featuring Robert Barto.',
      it: 'Recital di liuto con Robert Barto.'
    },
    fullDescription: {
      en: 'A concert featuring lute virtuoso Robert Barto performing galant repertoire, part of the Il Cantiere di Orfeo series at Auditorium Pittaluga in Alessandria.',
      it: 'Un concerto con il virtuoso del liuto Robert Barto che esegue repertorio galante, parte della serie Il Cantiere di Orfeo all\'Auditorium Pittaluga di Alessandria.'
    },
    type: 'concert',
    date: '2024-02-06',
    time: '21:00',
    location: {
      name: 'Auditorium Pittaluga',
      address: 'Via Parma 1, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://radiogold.it/news-alessandria/365124-cantiere-orfeo-conservatorio-alessandria-concerti/',
    performers: [
      'Il Cantiere di Orfeo',
      'Robert Barto (lute)'
    ],
    featured: false
  },
  {
    slug: 'cantiere-orfeo-consorts-songs-2024',
    title: {
      en: 'Consorts and songs',
      it: 'Consorts and songs'
    },
    description: {
      en: 'Chamber music concert at Chiesa di San Lorenzo.',
      it: 'Concerto di musica da camera alla Chiesa di San Lorenzo.'
    },
    fullDescription: {
      en: 'A chamber music concert featuring consorts and songs performed by Il Cantiere di Orfeo at the Church of San Lorenzo in Alessandria.',
      it: 'Un concerto di musica da camera con consorts e canzoni eseguito da Il Cantiere di Orfeo presso la Chiesa di San Lorenzo ad Alessandria.'
    },
    type: 'concert',
    date: '2024-05-18',
    time: '21:00',
    location: {
      name: 'Chiesa di San Lorenzo',
      address: 'Piazza San Lorenzo, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.alessandria24.com/2024/02/26/conservatorio-vivaldi-alessandria-calendario-eventi-dal-4-maggio-al-5-giugno-2024/',
    performers: [
      'Il Cantiere di Orfeo'
    ],
    featured: false
  },
  {
    slug: 'cantiere-orfeo-ecco-mormorar-2024',
    title: {
      en: 'Ecco Mormorar l\'onde',
      it: 'Ecco Mormorar l\'onde'
    },
    description: {
      en: 'Baroque concert at Chiesa di San Giovannino.',
      it: 'Concerto barocco alla Chiesa di San Giovannino.'
    },
    fullDescription: {
      en: 'A Baroque music concert performed by Il Cantiere di Orfeo at the Church of San Giovannino in Alessandria, featuring Monteverdi\'s "Ecco Mormorar l\'onde".',
      it: 'Un concerto di musica barocca eseguito da Il Cantiere di Orfeo presso la Chiesa di San Giovannino ad Alessandria, con "Ecco Mormorar l\'onde" di Monteverdi.'
    },
    type: 'concert',
    date: '2024-05-26',
    time: '21:00',
    location: {
      name: 'Chiesa di San Giovannino',
      address: 'Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://www.alessandria24.com/2024/02/26/conservatorio-vivaldi-alessandria-calendario-eventi-dal-4-maggio-al-5-giugno-2024/',
    performers: [
      'Il Cantiere di Orfeo'
    ],
    featured: false
  },
  {
    slug: 'biber-rosenkranzsonaten-complete-2025',
    title: {
      en: 'Biber: Complete Rosenkranzsonaten',
      it: 'Biber: Rosenkranzsonaten complete'
    },
    subtitle: {
      en: 'The 15 Mystery Sonatas + Passacaglia',
      it: 'Le 15 Sonate del Rosario + Passacaglia'
    },
    description: {
      en: 'Complete performance of Biber\'s Mystery Sonatas.',
      it: 'Esecuzione completa delle Sonate Mistero di Biber.'
    },
    fullDescription: {
      en: 'A complete performance of Heinrich Biber\'s Rosenkranzsonaten (all 15 Mystery Sonatas plus Passacaglia) directed by Claudio Andriani, featuring Nicola Bignami, Francesco Parrino, and students from Conservatorio Vivaldi.',
      it: 'Un\'esecuzione completa delle Rosenkranzsonaten di Heinrich Biber (tutte e 15 Sonate Mistero più Passacaglia) diretta da Claudio Andriani, con Nicola Bignami, Francesco Parrino e studenti del Conservatorio Vivaldi.'
    },
    type: 'concert',
    date: '2025-03-15',
    time: '18:00',
    location: {
      name: 'Chiesa di San Lorenzo',
      address: 'Via San Lorenzo 27, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://alessandria.today/2025/03/10/sabato-15-e-22-marzo-gli-appuntamenti-con-la-musica-barocca-in-san-lorenzo-comunicato-stampa/',
    performers: [
      'Il Cantiere di Orfeo',
      'Claudio Andriani (artistic director)',
      'Nicola Bignami',
      'Francesco Parrino',
      'Giulia Roveta (cello)',
      'Alessio Calabrese & Alessandro Pisa (theorbo/baroque guitar)',
      'Enrico Finotello (organ)'
    ],
    featured: false
  },
  {
    slug: 'biber-rosenkranzsonaten-2-2025',
    title: {
      en: 'Biber: Rosenkranzsonaten (Part 2)',
      it: 'Biber: Rosenkranzsonaten (Parte 2)'
    },
    subtitle: {
      en: 'Continuation of the Mystery Sonatas series',
      it: 'Continuazione della serie Sonate Mistero'
    },
    description: {
      en: 'Second part of Biber\'s Mystery Sonatas performance.',
      it: 'Seconda parte dell\'esecuzione delle Sonate Mistero di Biber.'
    },
    fullDescription: {
      en: 'Second concert in the complete Biber Rosenkranzsonaten series, continuing the performance of the Mystery Sonatas at Chiesa di San Lorenzo in Alessandria.',
      it: 'Secondo concerto nella serie completa delle Rosenkranzsonaten di Biber, continuando l\'esecuzione delle Sonate Mistero presso la Chiesa di San Lorenzo ad Alessandria.'
    },
    type: 'concert',
    date: '2025-03-22',
    time: '18:00',
    location: {
      name: 'Chiesa di San Lorenzo',
      address: 'Via San Lorenzo 27, Alessandria',
      city: 'Alessandria',
      country: 'Italy'
    },
    image: '/events/2017-modena-italico/italico-modena.jpg',
    ticketUrl: 'https://alessandria.today/2025/03/10/sabato-15-e-22-marzo-gli-appuntamenti-con-la-musica-barocca-in-san-lorenzo-comunicato-stampa/',
    performers: [
      'Il Cantiere di Orfeo',
      'Claudio Andriani (artistic director)'
    ],
    featured: false
  },
  {
    slug: 'viola-concert-finland-2012',
    title: {
      en: 'Viola Concerto',
      it: 'Concerto per Viola'
    },
    subtitle: {
      en: 'Composed by H. Puukko',
      it: 'Composto da H. Puukko'
    },
    description: {
      en: 'Viola concerto performance in Kouvola, Finland.',
      it: 'Esecuzione di concerto per viola a Kouvola, Finlandia.'
    },
    fullDescription: {
      en: 'Performance of a viola concerto composed by H. Puukko, presented in Kouvola, Finland as part of an international collaboration.',
      it: 'Esecuzione di un concerto per viola composto da H. Puukko, presentato a Kouvola, Finlandia come parte di una collaborazione internazionale.'
    },
    type: 'concert',
    date: '2012-01-01',
    time: '19:00',
    location: {
      name: 'Kouvola',
      address: 'Kouvola, Finland',
      city: 'Kouvola',
      country: 'Finland'
    },
    image: 'https://placehold.co/600x400/1E40AF/FFFFFF?text=Kouvola+Finland&font=playfair-display',
    ticketUrl: 'https://www.finnishviolasociety.com/archive',
    performers: [
      'Claudio Andriani'
    ],
    featured: false
  },
  {
    slug: 'palazzo-barolo-1998',
    title: {
      en: 'USA Spectrum Concert',
      it: 'Concerto USA Spectrum'
    },
    subtitle: {
      en: 'Featuring Federico Favali',
      it: 'Con Federico Favali'
    },
    description: {
      en: 'Concert featuring Federico Favali at Palazzo Barolo.',
      it: 'Concerto con Federico Favali a Palazzo Barolo.'
    },
    fullDescription: {
      en: 'A special concert at Palazzo Barolo featuring composer Federico Favali, presenting contemporary works in an historic setting.',
      it: 'Un concerto speciale a Palazzo Barolo con il compositore Federico Favali, presentando opere contemporanee in una cornice storica.'
    },
    type: 'concert',
    date: '1998-06-20',
    time: '21:00',
    location: {
      name: 'Palazzo Barolo',
      address: 'Via delle Orfane, 7, Torino',
      city: 'Turin',
      country: 'Italy'
    },
    image: 'https://placehold.co/600x400/8B4513/FFFFFF?text=Palazzo+Barolo&font=playfair-display',
    performers: [
      'Claudio Andriani',
      'Federico Favali (composer)'
    ],
    featured: false
  }
];

// Helper function to calculate event status dynamically
export const getEventStatus = (event) => {
  const now = new Date();
  const eventDate = new Date(event.date);
  
  // Set time to start of day for accurate comparison
  now.setHours(0, 0, 0, 0);
  eventDate.setHours(0, 0, 0, 0);
  
  return eventDate > now ? 'upcoming' : 'completed';
};

// Helper function to get upcoming events
export const getUpcomingEvents = () => {
  const now = new Date();
  return processedEvents
    .filter(event => getEventStatus(event) === 'upcoming')
    .sort((a, b) => new Date(a.date) - new Date(b.date));
};

// Helper function to get past events
export const getPastEvents = () => {
  const now = new Date();
  return processedEvents
    .filter(event => getEventStatus(event) === 'completed')
    .sort((a, b) => new Date(b.date) - new Date(a.date));
};

// Helper function to get featured events
export const getFeaturedEvents = () => {
  return processedEvents.filter(event => event.featured && getEventStatus(event) === 'upcoming');
};

// Helper function to get event by slug
export const getEventBySlug = (slug) => {
  const event = events.find(e => e.slug === slug);
  return event ? processEvent(event) : null;
};

// Helper function to get events by type
export const getEventsByType = (type) => {
  return processedEvents.filter(event => event.type === type);
};

// Helper function to get events by location
export const getEventsByLocation = (city) => {
  return processedEvents.filter(event => event.location.city.toLowerCase() === city.toLowerCase());
};

// Helper function to filter events
export const filterEvents = ({ type, location, status } = {}) => {
  let filteredEvents = [...processedEvents];

  if (type) {
    filteredEvents = filteredEvents.filter(event => event.type === type);
  }

  if (location) {
    filteredEvents = filteredEvents.filter(event => 
      event.location.city.toLowerCase().includes(location.toLowerCase()) ||
      event.location.name.toLowerCase().includes(location.toLowerCase())
    );
  }

  if (status) {
    filteredEvents = filteredEvents.filter(event => getEventStatus(event) === status);
  }

  return filteredEvents.sort((a, b) => new Date(a.date) - new Date(b.date));
};

// Helper function to get all unique event types
export const getEventTypes = () => {
  const types = new Set();
  events.forEach(event => types.add(event.type));
  return Array.from(types);
};

// Helper function to get all unique locations
export const getEventLocations = () => {
  const locations = new Set();
  events.forEach(event => locations.add(event.location.city));
  return Array.from(locations).sort();
};

// Helper function to format event date
export const formatEventDate = (date, endDate, language = 'en') => {
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  
  const locale = language === 'it' ? 'it-IT' : 'en-US';
  const formattedDate = new Date(date).toLocaleDateString(locale, options);
  
  if (endDate) {
    const formattedEndDate = new Date(endDate).toLocaleDateString(locale, options);
    return language === 'it' 
      ? `${formattedDate} - ${formattedEndDate}`
      : `${formattedDate} - ${formattedEndDate}`;
  }
  
  return formattedDate;
};

// Helper function to format event time
export const formatEventTime = (time) => {
  return time.substring(0, 5); // Remove seconds if present
};

// Asset path processing for subdirectory deployment
import { convertAssetPath } from '../utils/assetPath.js';

/**
 * Processes an event object to convert all image paths
 * @param {Object} event - The event object
 * @returns {Object} - The processed event object
 */
export const processEvent = (event) => {
  if (!event) return event;
  
  const processedEvent = { ...event };
  
  // Convert main image
  if (processedEvent.image) {
    processedEvent.image = convertAssetPath(processedEvent.image);
  }
  
  // Convert gallery images
  if (processedEvent.gallery && Array.isArray(processedEvent.gallery)) {
    processedEvent.gallery = processedEvent.gallery.map(convertAssetPath);
  }
  
  return processedEvent;
};

/**
 * Processes an array of events
 * @param {Array} events - Array of event objects
 * @returns {Array} - Array of processed event objects
 */
export const processEvents = (events) => {
  if (!Array.isArray(events)) return events;
  return events.map(processEvent);
};

// Process all events to convert image paths
export const processedEvents = processEvents(events);

// Export the processed events array as default
export default processedEvents;
